module.exports = {"130528001":"宁北街道","130528100":"凤凰镇","130528101":"河渠镇","130528102":"北河庄镇","130528103":"耿庄桥镇","130528104":"东汪镇","130528105":"贾家口镇","130528106":"四芝兰镇","130528107":"大陆村镇","130528108":"苏家庄镇","130528109":"换马店镇","130528110":"唐邱镇","130528111":"大曹庄镇","130528112":"侯口镇","130528202":"纪昌庄乡","130528205":"北鱼乡","130528208":"徐家河乡","130528401":"大曹庄管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130528.json
// module id = 228
// module chunks = 0